module.exports = __webpack_public_path__ + "static/media/banner_03.32d62296.png";